import { render, staticRenderFns } from "./ongoing-drum-picking.vue?vue&type=template&id=2636f0b2"
import script from "./ongoing-drum-picking.vue?vue&type=script&lang=js"
export * from "./ongoing-drum-picking.vue?vue&type=script&lang=js"
import style0 from "./ongoing-drum-picking.vue?vue&type=style&index=0&id=2636f0b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports